module.exports = __webpack_public_path__ + "img/33_72.bba6bb34.png";